import { useState, useEffect, useCallback } from 'react';
import { loucaApi } from '../services/loucaApi';

/**
 * Hook pour monitorer les endpoints en continu
 */
export const useEndpointMonitor = (endpoints = [], interval = 5000) => {
  const [status, setStatus] = useState({});
  const [isMonitoring, setIsMonitoring] = useState(false);

  const checkEndpoint = useCallback(async (endpoint) => {
    try {
      const startTime = Date.now();
      let response;
      
      switch (endpoint.name) {
        case 'configV3':
          response = await loucaApi.getConfigV3();
          break;
        case 'configV9':
          response = await loucaApi.getConfigV9();
          break;
        case 'llmModels':
          response = await loucaApi.getLLMModels();
          break;
        case 'sessions':
          response = await loucaApi.listSessionsV3();
          break;
        default:
          return { name: endpoint.name, status: 'unknown', error: 'Unknown endpoint' };
      }

      const duration = Date.now() - startTime;
      
      return {
        name: endpoint.name,
        status: 'success',
        duration,
        timestamp: new Date().toISOString(),
        data: response,
      };
    } catch (error) {
      return {
        name: endpoint.name,
        status: 'error',
        error: error.message,
        timestamp: new Date().toISOString(),
      };
    }
  }, []);

  const checkAllEndpoints = useCallback(async () => {
    const results = await Promise.all(
      endpoints.map(endpoint => checkEndpoint(endpoint))
    );
    
    const statusMap = {};
    results.forEach(result => {
      statusMap[result.name] = result;
    });
    
    setStatus(statusMap);
  }, [endpoints, checkEndpoint]);

  useEffect(() => {
    if (!isMonitoring || endpoints.length === 0) return;

    // Check immediately
    checkAllEndpoints();

    // Then check at interval
    const intervalId = setInterval(checkAllEndpoints, interval);

    return () => clearInterval(intervalId);
  }, [isMonitoring, endpoints, interval, checkAllEndpoints]);

  const startMonitoring = useCallback(() => {
    setIsMonitoring(true);
  }, []);

  const stopMonitoring = useCallback(() => {
    setIsMonitoring(false);
  }, []);

  return {
    status,
    isMonitoring,
    startMonitoring,
    stopMonitoring,
    checkAllEndpoints,
  };
};

export default useEndpointMonitor;



